import axios from 'axios'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FcGoogle } from 'react-icons/fc'
import { FaEye, FaEyeSlash, } from 'react-icons/fa'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import useGoogleAuthRedirect from '../hooks/useGoogleAuthRedirect'

const Signup = () => {
    const { t } = useTranslation()
    useGoogleAuthRedirect()

    const navigate = useNavigate()
    const params = useParams()

    const [loadingBtn, setLoadingBtn] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputValue, setInputValue] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        termsCondition: false

    });
    
    const inputHandler = (e) => {
        const {name, type, value, checked} = e.target;
        setInputValue({
            ...inputValue,
            [name]: type === 'checkbox' ? checked : value.trim(),
        })
    }

    const validate = () => {
        let errors = {};
        const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;

        if (!inputValue.email) {
            errors.email = "Email is required"
        } else if (emailReg.test(inputValue.email) === false) {
            errors.email = "Invalid Email";
        }

        if (!inputValue.password) {
            errors.password = "Password is required"
        }

        if (!inputValue.confirmPassword) {
            errors.confirmPassword = "Confirm Password is required"
        } else if (inputValue.password !== inputValue.confirmPassword) {
            errors.confirmPassword = "Password & Confirm Password is not matched"
        }

        if (!inputValue.termsCondition) {
            errors.termsCondition = "Please accept the terms and condition"
        }
    
        return errors;
    };

    const signupForm = async (e) => {
        e.preventDefault()

        const formErrors = validate();
        setErrors(formErrors);

        const signupData = {
            email: inputValue.email,
            password: inputValue.password,
            type: params.userType
        }
        
        
        if (Object.keys(formErrors).length === 0) {
            setLoadingBtn(true)
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/register`, signupData)
                const data = await response.data

                if(data.status === 0){
                    toast.error(data.message)
                }

                if(data.status === 1){
                    toast.success(data.message)
                    navigate('/signin')
                }

            } catch (error) {
                console.log('Error:', error);
            } finally {
                setLoadingBtn(false)
            }
        }
    }

    return (
        <>
            <div className='main-content'>
                <div className='padding login-section'>
                    <div className='container'>
                        <div className='login-box mx-auto'>
                            <h4 className='text-center mb-1'>{t('Welcome to LIMITS')}</h4>
                            <p className='text-center mb-5'>{t('Register to join us by entering your details below.')}</p>
                            
                            <form action="" className='form form1' onSubmit={signupForm}>
                                <div className='mb-3'>
                                    <input type="text" className="form-control" placeholder={t("Email")} name="email" onChange={inputHandler} />
                                    {errors.email && <p className="error-text">{errors.email}</p> }
                                </div>

                                <div className='mb-3'>
                                    <div className="icon-box">
                                        <input type={showPassword2 ? "text" : "password"}
                                            className="form-control form-control-user"
                                            placeholder={t("Create Password")}
                                            name="password" onChange={inputHandler}/>
                                        <Link className="icon1"
                                            onClick={() => setShowPassword2(!showPassword2)}>
                                            {showPassword2 ? <FaEyeSlash /> : <FaEye />}
                                        </Link>
                                    </div>
                                    {errors.password && <p className="error-text">{errors.password}</p> }
                                </div>

                                <div className='mb-3'>
                                    <div className="icon-box">
                                        <input type={showPassword ? "text" : "password"}
                                            className="form-control form-control-user"
                                            placeholder={t("Confirm Password")}
                                            name="confirmPassword" onChange={inputHandler}/>
                                        <Link className="icon1"
                                            onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </Link>
                                    </div>
                                    {errors.confirmPassword && <p className="error-text">{errors.confirmPassword}</p> }
                                </div>

                                <div className='mb-3 mt-4'>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="formCheckDefault" name="termsCondition" value="" onChange={inputHandler} />
                                        <label className="form-check-label" htmlFor="formCheckDefault">{t('I agree to Terms and Conditions')}</label>
                                    </div>
                                    {errors.termsCondition && <p className="error-text">{errors.termsCondition}</p> }
                                </div>

                                <div className='mt-3'>
                                    <button type='submit' className='btn btn1 w-100 mt-4' disabled={loadingBtn}>{t('Register')}</button>
                                </div>
                            </form>

                            <div className='or position-relative text-center my-4 py-2'>
                                <p className='mb-0'>Or</p>
                            </div>

                            <div className='mt-3'>
                                <Link to={`${process.env.REACT_APP_API_URL}/auth/google?type=${params.userType}`} target='_parent' className='btn btn1 btn-border w-100'><FcGoogle className='align-middle fs-4 me-2' /> <span className='align-middle'>{t('Continue with Google')}</span></Link>
                            </div>
                            <p className='mb-0 text-center mt-3'>{t('Have an account? Login')} <span className='text-white'><Link to="/signin" className='link text-decoration-underline fw-medium'>{t('Login')}</Link></span></p>
                            <p className='mb-0 text-center mt-3'><span className='text-white'><Link to="/" className='link text-decoration-underline fw-medium'>Enter</Link></span></p>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Signup
